module.exports = __webpack_public_path__ + "static/img/04.4f1765fe.jpg";